// extracted by mini-css-extract-plugin
export default {"productDescription":"r2-z","featuredDescription":"s2-z","description":"t2-z","more":"u2-z","descriptionSku":"v2-z"};